<template>
  <div
    class="relative flex h-dvh flex-col lg:aspect-video lg:h-auto"
    @click="data.video ? showVideo(data.video?.url) : undefined"
  >
    <VideoLoop
      v-if="data.videoLoop"
      :width="data.videoLoop?.width"
      :height="data.videoLoop?.height"
      :sources="[
        {
          src: data.videoLoop?.url,
          type: 'video/mp4'
        }
      ]"
      class="absolute inset-0 z-1 mx-auto h-full max-h-full w-full object-cover"
      muted
      autoplay
      preload="metadata"
      loop
      playsinline
    />
    <Image
      v-else-if="data.thumbnail"
      class="absolute inset-0 z-1 mx-auto h-full w-full object-cover"
      :src="
        data.thumbnail.responsiveImage ? data.thumbnail.responsiveImage?.src : data.thumbnail.url
      "
      :srcset="
        data.thumbnail.responsiveImage ? data.thumbnail.responsiveImage?.webpSrcSet : undefined
      "
      :width="
        data.thumbnail.responsiveImage
          ? data.thumbnail.responsiveImage?.width
          : (data.thumbnail.width ?? 20)
      "
      :height="
        data.thumbnail.responsiveImage
          ? data.thumbnail.responsiveImage?.height
          : (data.thumbnail.height ?? 20)
      "
      :alt="data.thumbnail?.alt ?? ''"
    />
  </div>
</template>

<script setup lang="ts">
const { showVideo } = useModal()

defineProps({
  data: {
    type: Object as PropType<VideoBlockRecord>,
    default: () => {}
  }
})
</script>
